import React, { useEffect, useState } from 'react';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import { FaRegCheckCircle } from 'react-icons/fa';
import {
  ColumnGap,
  FilterClearButton,
  FilterContainer,
  FlexDirectionWrapper,
  MainContent,
  Row,
  SubTitle,
  Text,
  WrapperLegend,
} from '../../../../../components/StyledComponents';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { useHistory } from 'react-router-dom';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Accordion from '@material-ui/core/Accordion';
import { ExcelExportAdmin } from '../../../../../components/ExcelExportAdmin';
import { formatDateToBR } from '../../../../../utils/time';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import axios from 'axios';
import { ProjetoAcoesService } from '../../../services/projetoAcoesService';
import {removeEmpty, sortByDirection} from '../../../../../utils/utils';
import moment from 'moment';
import { Grid } from "@mui/material";
import { FilterSelectAdmin } from "../../../../../components/FilterSelectAdmin";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export const GerenciarProjetosAcoes = () => {
  const history = useHistory();
  const { showModal } = React.useContext(BaSeDialogContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [pendants, setPendants] = useState(0);
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [inputSearchValue, setInputSearchValue] = useState(null);
  const [paginationFilters, setPaginationFilters] = useState({
    page: 0,
    linesPerPage: 10,
    orderBy: 'id',
    direction: 'DESC',
  });

  const getDataExcel = async () => {
    const source = axios.CancelToken.source();
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 1000 };
    const response = await ProjetoAcoesService.findAll(
      pageFilter,
      bodyParams,
      source
    );
    return response?.content?.map((r) =>
      removeEmpty({
        DATA: r?.dataCriacao ? moment(r?.dataCriacao).format('DD/MM/YYYY') : '',
        CodigoPRATIF: r?.nuPratif,
        UF: r?.uf?.sigla,
        NOME: r?.nomePratif,
        ACAO: r?.acoes.map((ac) => ac?.nomeAcao),
        STATUS: r?.status,
      })
    );
  };

  const getData = async (source) => {
    try {
      const bodyParams = removeEmpty({ ...filters, oqueVoceProcura: inputSearchValue });
      const response = await ProjetoAcoesService.findAll(
          paginationFilters,
          bodyParams,
          source
      );
      setData(response);
      getPendants();
      return response;
    } catch (e) {
      console.log('Erro ao buscar dados Projetos e Acoes:', e)
    } finally {
      setIsLoading(false);
    }
   
  };

  const getPendants = async () => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    const response = await ProjetoAcoesService.getPedants(bodyParams);
    setPendants(response);
  };

  const changeStatus = async (projetoStatus) => {
    return await ProjetoAcoesService.changeStatus(
      projetoStatus.id ?? projetoStatus
    );
  };

  const deleteProjeto = async (id) => {
    return await ProjetoAcoesService.delete(id);
  };

  const onLinesPerPageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      linesPerPage: value,
      page: 0,
    });
  };

  const handlePageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      page: value,
    });
  };

  const handleOrderClick = ({ orderBy, direction }) => {
    const orderActions =
      orderBy === 'acoes.nomeAcao'
        ? 'id'
        : orderBy === 'uf.sigla'
        ? 'uf'
        : orderBy;
    setPaginationFilters({
      ...paginationFilters,
      orderBy: orderActions,
      direction: direction,
    });
  };

  const handleInputPageChange = (newValue) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: newValue,
    });
  };

  const handleFilterByStatus = (status) => {
    setIsLoading(true);
    if (JSON.stringify(status) === JSON.stringify(filters?.status)) {
      setFilters((f) => ({ ...f, status: null }));
      return;
    }
    setFilters((f) => ({ ...f, status: status }));
    setPaginationFilters({
      ...paginationFilters,
      page: 0,
    });
  };

  const handleStateClick = (item) => {
    handleModalAdmin({
      title: `${
        item.status === 'ATIVO' ? 'Desaprovar' : 'Aprovar'
      } Projeto e ação`,
      content: `Você tem certeza que deseja ${
        item.status === 'ATIVO' ? 'Desaprovar' : 'Aprovar'
      } esse projeto e ação?`,
      msgOnSuccess: `Projeto e ação ${
        item.status === 'ATIVO' ? 'Desaprovado' : 'Aprovado'
      } com sucesso`,
      msgOnError: `O projeto e ação não foi ${
        item.status === 'ATIVO' ? 'Desaprovado' : 'Aprovado'
      } Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: () => changeStatus(item),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleDeleteClick = (item) => {
    handleModalAdmin({
      title: `Excluir projeto e ação`,
      content: `O projeto e ação será excluído, deseja continuar?`,
      msgOnSuccess: `Projeto e ação excluído com sucesso`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: () => deleteProjeto(item),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleEditClick = (id) => {
    history.push(`/tabelas-de-controle/projetosAcoes/${id}/edit`);
  };

  const onClickClearFilters = () => {
    setIsLoading(true);
    setData([]);
    setInputSearchValue(null);
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: 'id',
      direction: 'DESC',
    });
    setFilters({
      status: '',
    });
  };
  
  const getOptionsData = async () => {
    setFilterOptions({});
    try {
      const response = await ProjetoAcoesService.getOptions(false);
      console.log('response', response)
      setFilterOptions(response);
    } catch (e) {
      console.log('Erro ao buscar Opcoes Projetos Acoes: ', e)
    }
  };
  
  useEffect(() => {
    getOptionsData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setData([]);
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, paginationFilters, inputSearchValue]);

  const tableColumns = [
    {
      field: 'dataCriacao',
      id: 'dataCriacao',
      label: 'Data',
      minWidth: 10,
    },
    {
      field: 'nuPratif',
      id: 'nuPratif',
      label: 'Cód. PRATIF',
      minWidth: 10,
      align: 'left',
    },
    {
      field: 'uf',
      subfield: 'sigla',
      id: 'uf',
      label: 'UF',
      minWidth: 10,
      align: 'left',
    },
    {
      field: 'nomePratif',
      id: 'nomePratif',
      label: 'Nome do Projeto',
      minWidth: 70,
      align: 'left',
    },
    {
      field: 'acoes',
      subfield: 'nomeAcao',
      id: 'acoes',
      label: 'Ações',
      minWidth: 80,
      align: 'left',
    },
    {
      field: 'actions',
      id: 'actions',
      label: 'Status',
      minWidth: 150,
      align: 'left',
    },
  ];
  
  const onChangeItemFilter = (event, field, asArray =  false) => {
    event.stopPropagation();
    const fieldValue = event.target.value
        ? JSON.parse(event.target.value)
        : event.target.value;
    setFilters({ ...filters, [field]: !asArray ? fieldValue : [fieldValue] });
  };

  const renderFilters = (color) => {
    return (
      <FilterContainer>
        <Accordion
          style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}
        >
          <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="accordion-filter"
              id="accordion-filter"
          >
            <BaSeIcon
              name="filter"
              color={color}
              size={25}
              description="Ícone de filtro"
            />
            <p style={{ color: color, fontWeight: 'bold' }}>Filtrar</p>
            <FilterClearButton
              color={color}
              onClick={(e) => {
                e.stopPropagation();
                onClickClearFilters();
              }}
            >
              <BaSeIcon
                name="close"
                size={10}
                color={color}
                description="Limpar filtros"
              />
              <p
                style={{
                  fontSize: '12px',
                  color: color,
                  borderBottom: `1px solid ${color}`,
                }}
              >
                Limpar filtros
              </p>
            </FilterClearButton>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container rowSpacing={1} spacing={1.3} >
              <Grid item md={2} xs={2} sm={3} >
                <FilterSelectAdmin
                    label="UF"
                    placeholder={'Selecione uma opção'}
                    options={sortByDirection(filterOptions?.ufs, 'sigla')}
                    value={filters?.uf}
                    optionLabel={'sigla'}
                    onChangeItem={(event) => onChangeItemFilter(event, 'uf')}
                />
              </Grid>
              <Grid item md={2} xs={2} sm={3}>
                <FilterSelectAdmin
                    label="Nome do Projeto"
                    placeholder={'Selecione uma opção'}
                    options={filterOptions?.nomePratif}
                    value={filters?.nomePratif}
                    onChangeItem={(event) => onChangeItemFilter(event, 'nomePratif')}
                />
              </Grid>
              <Grid item md={2} xs={2} sm={3}>
                <FilterSelectAdmin
                    label="Nome da ação"
                    placeholder={'Selecione uma opção'}
                    options={sortByDirection(filterOptions?.acoes, 'nomeAcao')}
                    value={filters?.acoes?.length && filters?.acoes[0]}
                    optionLabel={'nomeAcao'}
                    returnAsObject={true}
                    onChangeItem={(event) =>
                        onChangeItemFilter(event, 'acoes', true)
                    }
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </FilterContainer>
    );
  };

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
          />
        </>
      </SubTitle>

      {renderFilters('#B3B3B3')}

      <WrapperLegend>
        <ColumnGap
          gap="7px"
          padding="6px 10px"
          backgroundColor={!!pendants && 'rgba(196, 196, 196, 0.2)'}
        >
          {!!pendants && (
            <>
              <BaSeIcon
                name="exclamation-circle"
                size={28}
                color="#ff0000"
                description={'Gerenciamento'}
              />
              <Row align="center">
                <Text color="#B3B3B3">Existem&nbsp;</Text>
                <Text color="#ff0000" weight="bold">
                  {pendants} &nbsp;
                </Text>
                <Text color="#B3B3B3">itens aguardando aprovação.</Text>
              </Row>
            </>
          )}
        </ColumnGap>

        <FlexDirectionWrapper>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => handleFilterByStatus('ATIVO')}
          >
            <FaRegCheckCircle size={25} color="#0061C6" />
            <Text margin="4px" color="#B3B3B3">
              Aprovado
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => handleFilterByStatus('INATIVO')}
          >
            <FaRegCheckCircle size={25} color="#FF0000" />
            <Text margin="4px" color="#B3B3B3">
              Aguardando aprovação
            </Text>
          </div>
        </FlexDirectionWrapper>
      </WrapperLegend>

      <FlexDirectionWrapper
        style={{ justifyContent: 'space-between', marginTop: '12px' }}
      >
        <div>
          <p style={{ fontWeight: 'bold', color: '#0061C6' }}>
            {data?.totalElements ?? 0}
            <strong className="find-results"> resultados encontrados </strong>
          </p>
        </div>

        <ExcelExportAdmin
          filename={`Exportacao_Projeto_Acoes${formatDateToBR(new Date())}`}
          handleDataCallback={getDataExcel}
          isCsv
        />
      </FlexDirectionWrapper>
      <TableAdmin
        data={data}
        columnAction={'actions'}
        paginationFilters={paginationFilters}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        isLoading={isLoading}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        onLinesPerPageChange={onLinesPerPageChange}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        handleDeleteClick={handleDeleteClick}
        handleEditClick={handleEditClick}
        handleOrderClick={handleOrderClick}
        onInputPageChange={handleInputPageChange}
        handleStateClick={handleStateClick}
      />
    </MainContent>
  );
};
